import { getImagePath } from '@/utils/images';
import { Container } from './WebinarShared';
import WebinarHtml from './WebinarHtml';

const LogoRow = ({ logos }) => {
  const list = logos || [];
  if (list.length === 0) return null;
  return (
    <div className="mx-auto my-12 flex w-full flex-wrap items-center justify-center gap-12 px-4 py-4">
      {list.map((logo) => (
        <img
          key={logo.id || logo.url}
          src={getImagePath(logo)}
          alt={logo.alternativeText || ''}
          className="max-h-9 w-auto object-contain opacity-50 transition-opacity duration-700 hover:opacity-100"
        />
      ))}
    </div>
  );
};

const WebinarLogos = ({ groups, ctaLabel, ctaUrl }) => {
  const list = groups || [];
  if (list.length === 0) return null;

  return (
    <section className="bg-white py-14">
      <Container>
        {list.map((group, i) => (
          <div key={group.id}>
            {i > 0 && <div className="mx-auto mb-7 h-px w-full max-w-[1176px] bg-[#e5e5e5]" />}
            {group.label && (
              <WebinarHtml
                html={group.label}
                className="text-center text-sm font-semibold tracking-[0.06em] text-grey-500 uppercase [&_strong]:font-semibold [&_strong]:text-brand-500"
              />
            )}
            <LogoRow logos={group.logos} />
          </div>
        ))}

        {ctaLabel && (
          <div className="mt-16 mb-16 flex justify-center">
            <a
              href={ctaUrl || '#prihlaska'}
              className="inline-flex items-center justify-center rounded-full bg-brand-400 px-7 py-[15px] text-base text-white transition-colors hover:bg-brand-500"
            >
              {ctaLabel}
            </a>
          </div>
        )}
      </Container>
    </section>
  );
};

export default WebinarLogos;
